export enum MetadataTestIds {
  CreateMetadataFieldButton = 'CreateMetadataFieldButton',
  CreateMetadataFieldSubmitButton = 'CreateMetadataFieldSubmitButton',
  EditMetadataFieldSubmitButton = 'EditMetadataFieldSubmitButton',
  MetadataFieldNameInput = 'MetadataFieldNameInput',
  MetadataFieldTypeSelect = 'MetadataFieldTypeSelect',
  MetadataFieldTypeText = 'MetadataFieldTypeText',
  MetadataFieldTypeNumber = 'MetadataFieldTypeNumber',
  MetadataFieldTypeBoolean = 'MetadataFieldTypeBoolean',
  MetadataFieldTypeUrl = 'MetadataFieldTypeUrl',
  MetadataTable = 'MetadataTable',
  MetadataEditButton = 'MetadataEditButton',
  MetadataDeleteButton = 'MetadataDeleteButton',
}
